export class CnpjUtils {
  static normalizar(valor: string | null | undefined): string {
    if (!valor) {
      return '';
    }
    return valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  }

  static filtrar(valor: string | null | undefined): string {
    const raw = CnpjUtils.normalizar(valor);
    let resultado = '';
    for (let i = 0; i < raw.length && i < 14; i++) {
      const char = raw[i];
      if (i < 12) {
        if (/[A-Z0-9]/.test(char)) {
          resultado += char;
        }
      } else {
        if (/[0-9]/.test(char)) {
          resultado += char;
        }
      }
    }
    return resultado;
  }

  static formatar(valor: string | null | undefined): string {
    const normalizado = CnpjUtils.normalizar(valor);
    if (normalizado.length !== 14) {
      return normalizado;
    }
    return `${normalizado.substring(0, 2)}.${normalizado.substring(2, 5)}.${normalizado.substring(5, 8)}/${normalizado.substring(8, 12)}-${normalizado.substring(12, 14)}`;
  }

  static validarDigitos(valor: string | null | undefined): boolean {
    try {
      const normalizado = CnpjUtils.normalizar(valor);
      if (normalizado.length !== 14) {
        return false;
      }
      const base = normalizado.substring(0, 12);
      const dvInformado = normalizado.substring(12, 14);
      if (!/^[0-9A-Z]{12}$/.test(base)) {
        return false;
      }
      if (!/^[0-9]{2}$/.test(dvInformado)) {
        return false;
      }
      const charToNumber = (char: string): number => {
        if (/^[0-9]$/.test(char)) {
          return parseInt(char, 10);
        }
        return char.charCodeAt(0) - 48;
      };
      const calcularDv = (documento: string, pesos: number[]): number => {
        let soma = 0;
        for (let i = 0; i < documento.length; i++) {
          soma += charToNumber(documento[i]) * pesos[i];
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
      };
      const dv1 = calcularDv(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
      const dv2 = calcularDv(`${base}${dv1}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
      return `${dv1}${dv2}` === dvInformado;
    } catch (error) {
      return false;
    }
  }

  static isValido(valor: string | null | undefined): boolean {
    return CnpjUtils.validarDigitos(valor);
  }
}
